var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import AreaOfStudyDomainService from "../Domain/AreaOfStudy/AreaOfStudy.service";
const BASE_URL = "/aviso/areaOfStudy";
export default class AreaOfStudyService {
    static studentAreaOfStudyInfo(studentId) {
        return FetchService.getSingleResponse(BASE_URL + "/studentAreaOfStudyInfo", {
            studentId,
        });
    }
    static findByIds(ids, type) {
        return __awaiter(this, void 0, void 0, function* () {
            return AreaOfStudyService.search({
                ids,
                areaOfStudyTypeIds: [type],
                active: true,
            }).then(({ data }) => data);
        });
    }
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const searchResults = yield FetchService.getPagedResponse(BASE_URL + "/search", {
                query: search.query,
                active: search.active,
                ids: search.ids,
                codes: search.codes,
                areaOfStudyTypeIds: search.areaOfStudyTypeIds,
                srcSystemIds: search.srcSystemIds,
                names: search.names,
                max: options.max,
                offset: options.offset,
                sort: options.sort,
                order: options.order,
            });
            return Object.assign(Object.assign({}, searchResults), { data: searchResults.data.map(AreaOfStudyDomainService.fromJSON) });
        });
    }
    static get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/get", {
                id,
            }).then(AreaOfStudyDomainService.fromJSON);
        });
    }
    static save(request) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/save", request).then(AreaOfStudyDomainService.fromJSON);
        });
    }
}
